import { useQuery } from "react-query";
import { apiRequests } from "src/shared/api/api";
import { useFetchAllData } from "src/shared/lib/hooks/context";

export const useFetchGetWarehouses = (options) => {
  const { token, name, } = options;
  const query = useQuery(
    ["warehouses", token, name],
    async () => {
      const response = await apiRequests.warehouses.getItems({ token, name });
      return response.data.result;
    }
  );
  return query;
};


export const useFetchAllWarehouses = ({ token }) =>
  useFetchAllData({ token, key: "warehouses", path: "warehouses/" });
